const checkIsCustomCarSearchType = ({
  isOneWay,
  flightItineraryTypeCode,
  carSearchType,
  hasFlights,
  hasHotels,
  hotels
}) => {
  return (
    carSearchType === 'custom' ||
    // If there are multiple hotels, and no round trip flight, it's difficult to know what to inherit from
    ((!hasFlights || isOneWay) && hasHotels && hotels.length > 1) ||
    // If there is no hotel, but there is a one-way flight, there is no end date to reference
    (!hasHotels && hasFlights && isOneWay)
  )
}

export default checkIsCustomCarSearchType
